import { IconName, IconPrefix } from '@fortawesome/fontawesome-svg-core';
import { CustomActionButton } from 'pages/custom/shared/CustomHeader/CustomActionButton';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    buttons: Array<{
        label: string;
        onClick: () => void;
        icon: {
            iconSet: IconPrefix;
            iconName: IconName;
        };
    }>;
}

export const CustomButtons = (props: Props): JSX.Element => {
    return (
        <S_CustomButtons className={props.className}>
            {props.buttons.map((button) => (
                <S_Button
                    key={button.label}
                    iconSet={button.icon.iconSet}
                    iconName={button.icon.iconName}
                    text={button.label}
                    onClick={button.onClick}
                />
            ))}
        </S_CustomButtons>
    );
};

const S_CustomButtons = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 1259px) {
        width: unset;
    }
`;

const S_Button = styled(CustomActionButton)`
    width: 100%;
    @media only screen and (min-width: 1259px) {
        min-width: 150px;
        width: unset;
    }
`;
